import { render, staticRenderFns } from "./cgggNoticeInfo.vue?vue&type=template&id=12152320&"
import script from "./cgggNoticeInfo.vue?vue&type=script&lang=js&"
export * from "./cgggNoticeInfo.vue?vue&type=script&lang=js&"
import style0 from "./cgggNoticeInfo.vue?vue&type=style&index=0&id=12152320&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports